<template>
  <div class="shop-detail">
    <div class="header">
    <TopBar :title ="$t('mine.dhxx')" />
    </div>
    <div class="body">
      <van-form>
        <van-field
          v-model="payPal"
          name="Paypal"
          label="Paypal"
          placeholder=""
        />
        <van-field
          v-model="userName"
          :name="$t('name')"
          :label="$t('name')"
          placeholder=""
        />
      </van-form>
      <div style="margin: 16px;color: #C75353;line-height:.5rem;font-weight:bold;">
       {{ $t('tipsP') }}
      </div>
      <div style="margin: 1.5rem 16px;" class="btn">
        <van-button round block type="info" @click="onSubmit" :disabled="$store.state.loginInfo.paypalConfirmed">{{$t('btnP')}}</van-button>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import {accountsPaypal} from '@/api/api.js';
  import { Notify } from 'vant';
  import TopBar from '@/common/top-bar/index.vue'

  export default {
    name: 'UpdateInfo',
    components: {
      TopBar
    },
    data () {
      return {
        payPal: this.$store.state.loginInfo.paypal,
        userName: this.$store.state.userInfo.name
      }
    },
    methods: {
      onClickLeft(){
        this.$router.go(-1);
      },
      onSubmit(){
        this.setInfo()
        
      },
      setInfo(){
        const loginInfo = JSON.parse(localStorage.getItem('LOGIN_INFO'));
        const params = {
          type:1,
          name:this.userName,
          account:this.payPal}
        accountsPaypal(params).then(res=>{
          if(res.code === 200) {
          Toast.success({
          className: 'noticeWidth',
          message: res.memo,
          forbidClick: true,
            });
          this.$router.replace("/shopDetail")
          }else{
            Notify({ type: 'warning', message: res.errors});
          }
        })
      }
    },
    mounted () {
    },
    activated () {
    }
  }
</script>

<style lang="stylus" scoped>
  /deep/.shop-detail{
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-color: #F3F3F3;
    .body{
      padding:0 .3rem;
      margin-top: .2rem;
      border-radius: 18px;

      .van-cell:nth-child(1){
        border-radius: 18px 18px 0 0;
      }
      .van-cell:nth-child(2){
        border-radius: 0 0 18px 18px;
      }
      
      .btn{
        button{
          font-size: 22px;
          background: #FBC260;
          border: #FBC260;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/updateInfo/UpdateInfo.vue